import { comparisonData } from '@/mocks/vigorbuy-data';

export default function ComparisonTable() {
  return (
    <section id="comparison" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-4">
          VigorBuy Spreadsheet vs Traditional Product Search
        </h2>
        <p className="text-center text-foreground-500 text-sm md:text-base mb-10 max-w-2xl mx-auto">
          See how the VigorBuy Spreadsheet approach transforms your product discovery experience
        </p>

        <div className="overflow-x-auto rounded-xl border border-background-200/70">
          <table className="w-full text-sm">
            <thead>
              <tr className="bg-background-100">
                <th className="text-left px-5 py-4 font-semibold text-foreground-900 whitespace-nowrap">Feature</th>
                <th className="text-left px-5 py-4 font-semibold text-foreground-600 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-search-line text-foreground-400"></i>
                    Traditional Search
                  </span>
                </th>
                <th className="text-left px-5 py-4 font-semibold text-primary-600 whitespace-nowrap">
                  <span className="flex items-center gap-2">
                    <i className="ri-star-line text-primary-400"></i>
                    VigorBuy Spreadsheet
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, idx) => (
                <tr key={idx} className={`${idx % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'} border-t border-background-200/50`}>
                  <td className="px-5 py-4 font-medium text-foreground-900 whitespace-nowrap">{row.feature}</td>
                  <td className="px-5 py-4 text-foreground-500">{row.traditional}</td>
                  <td className="px-5 py-4 text-primary-600 font-medium">{row.vigorbuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}